var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 14V10M11.1667 12H15.1667M15.1667 6.66666H1.83334M15.1667 8V5.46666C15.1667 4.71993 15.1667 4.34656 15.0214 4.06134C14.8935 3.81046 14.6895 3.60649 14.4387 3.47865C14.1534 3.33333 13.7801 3.33333 13.0333 3.33333H3.96668C3.21994 3.33333 2.84657 3.33333 2.56136 3.47865C2.31047 3.60648 2.1065 3.81046 1.97867 4.06134C1.83334 4.34656 1.83334 4.71992 1.83334 5.46666V10.5333C1.83334 11.2801 1.83334 11.6534 1.97867 11.9386C2.1065 12.1895 2.31047 12.3935 2.56136 12.5213C2.84657 12.6667 3.21994 12.6667 3.96668 12.6667H8.50001",
    stroke: "#AADE16",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardPlus);
export default __webpack_public_path__ + "static/media/credit-card-plus.262dfbdff9e462c1277779596de1a8d4.svg";
export { ForwardRef as ReactComponent };